import Series from "./components/serie/Series";
import Login from './components/login/Login';
import { Route, Routes } from "react-router";
import { Navigate } from 'react-router-dom';
import Tome from "./components/tome/Tome";
import LogOut from "./components/logout/LogOut";
import Edition from "./components/edition/Edition";
import Profile from "./components/profile/Profile";
import SignUp from "./components/signup/SignUp";
import Settings from "./components/settings/Settings";


function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Navigate to="/series" />} />
        <Route path="/series" element={<Series />} />
        <Route path="/tome/:id" element={<Tome />} />
        <Route path="/edition/:id" element={<Edition />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/logout" element={<LogOut />} />
      </Routes>
    </div>
  );
}

export default App;
